import { mutatorAction } from "satcheljs";
import type { PeopleRefinerSelection } from "../store/schema/PeopleRefinerSelection";
import getStore from "../store/store";

export const addFromRefinerSelectionMutator: (selection: PeopleRefinerSelection) => void = mutatorAction("addFromRefinerSelection", (selection: PeopleRefinerSelection): void => {
    const store = getStore();
    if (store.fromRefinerSelections.some(item => item.id === selection.id)) {
        return;
    }
    
    store.fromRefinerSelections.push(selection);
});

export const removeFromRefinerSelectionMutator: (selectionId: string) => void = mutatorAction("removeFromRefinerSelection", (selectionId: string): void => {
    const store = getStore();
    store.fromRefinerSelections = store.fromRefinerSelections.filter(selection => selection.id !== selectionId);
});
